import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../../Assets/CSS/Styles.scss";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`http://localhost:8000/api/blogs/${id}`)
      .then((res) => {
        setBlog(res.data);
      })
      .catch((err) => {
        console.error("Error fetching blog:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!blog) return <p className="text-center py-10">No blog available.</p>;

  return (
    <div className="container mx-auto px-6 py-12 max-w-4xl mt60">
     

      {/* Blog Image */}
      {blog.image && (
        <img
          src={`http://localhost:8000/uploads/${blog.image}`}
          alt={blog.title}
          className="w-full h-96 object-cover mb-6"
        />
      )}

       {/* Title */}
      <h1 className="text-4xl font-bold mb-4">{blog.title}</h1>

      {/* Author & Date */}
      <p className="text-gray-500 mb-6">
        By {blog.author || "Unknown"} •{" "}
        {blog.publishDate
          ? new Date(blog.publishDate).toLocaleDateString()
          : "No date"}
      </p>

      {/* Blog Sections */}
      {blog.sections &&
        blog.sections.length > 0 &&
        blog.sections.map((section, index) => (
          <div key={index} className="mb-6">
            {section.title && (
              <h2 className="text-2xl font-semibold mb-2">{section.title}</h2>
            )}
            {section.description && <p className="mb-2">{section.description}</p>}
            {section.points && section.points.length > 0 && (
              <ul className="list-disc ml-6">
                {section.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
    </div>
  );
};

export default BlogDetail;
